export const FormUtility = {
    getIndexedFieldName: function (fieldName: string, indices: string[]) {
        return fieldName + '---' + indices.join('---');
    },
}